import { useState } from "react";
import { useSettings } from "@/contexts/SettingsContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Car, Eye, EyeOff, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
const API = process.env.REACT_APP_BACKEND_URL;

export default function ResetPasswordPage() {
  const { settings } = useSettings();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Le password non corrispondono"); return; }
    if (password.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    setSubmitting(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
      toast.success("Password reimpostata!");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore nel reset della password");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-slate-950 p-6">
      <div className="w-full max-w-md space-y-8">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: settings?.primary_color || "#DC2626" }}>
            <Car className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-bold font-outfit text-slate-900 dark:text-slate-100">
            {settings?.app_name || "RG Rent"}
          </span>
        </div>

        {done ? (
          <div className="text-center space-y-4 py-8">
            <div className="w-16 h-16 rounded-full bg-emerald-50 dark:bg-emerald-950 flex items-center justify-center mx-auto">
              <CheckCircle2 className="w-8 h-8 text-emerald-500" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Password Reimpostata!</h2>
            <p className="text-sm text-slate-500">Ora puoi accedere con la nuova password.</p>
            <Button onClick={() => navigate("/login")} style={{ backgroundColor: settings?.primary_color || "#DC2626" }} className="text-white hover:opacity-90">
              Vai al Login
            </Button>
          </div>
        ) : (
          <>
            <div>
              <h1 className="text-3xl font-bold font-outfit text-slate-900 dark:text-white">Nuova Password</h1>
              <p className="text-slate-500 dark:text-slate-400 text-sm mt-2">Inserisci la tua nuova password</p>
            </div>
            {!token && (
              <div className="p-4 bg-red-50 dark:bg-red-950 rounded-lg text-sm text-red-600 dark:text-red-400">
                Link di reset non valido. Richiedi un nuovo link dalla pagina di login.
              </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="space-y-2">
                <Label className="text-slate-700 dark:text-slate-200">Nuova Password</Label>
                <div className="relative">
                  <Input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)}
                    placeholder="Almeno 6 caratteri" className="h-11 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg pr-10" required />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
                    {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <div className="space-y-2">
                <Label className="text-slate-700 dark:text-slate-200">Conferma Password</Label>
                <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                  placeholder="Ripeti la password" className="h-11 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 rounded-lg" required />
              </div>
              <Button type="submit" disabled={submitting || !token} style={{ backgroundColor: settings?.primary_color || "#DC2626" }}
                className="w-full h-11 hover:opacity-90 text-white font-medium rounded-lg">
                {submitting ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : "Reimposta Password"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
